import API from "./api";

// ✅ GET ALL
export const getCustomers = () => API.get("/Customer");

// ✅ ADD
export const addCustomer = (data) =>
    API.post("/Customer", data);

// ✅ UPDATE
export const updateCustomer = (id, data) => {
    return API.put(`/Customer/${id}`, data);   // ✅ FIX
};

export const deleteCustomer = (id) => {
    return API.delete(`/Customer/${id}`);      // ✅ FIX
};
// ✅ NEXT CODE
export const getNextCustomerCode = () =>
    API.get("/Customer/next-code");